import { render, staticRenderFns } from "./CategoriesColumn.vue?vue&type=template&id=9a0fa9ee&scoped=true"
import script from "./CategoriesColumn.vue?vue&type=script&lang=js"
export * from "./CategoriesColumn.vue?vue&type=script&lang=js"
import style0 from "./CategoriesColumn.vue?vue&type=style&index=0&id=9a0fa9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0fa9ee",
  null
  
)

export default component.exports